import React, { Component } from 'react'

/**
 * vagy offsetet kell megadni,vagy offsetClassName-t
 * offsetClassName akkor jöhet jól, ha css mediaquery-vel akarjuk befolyásolni az offsetet
 * (a megadott offsetClassName-en természetesen be kell állítani a `top` értékét)
 */
class ScrollOffset extends Component {
  render() {
    let offsetStyle = {
      position: 'absolute'
    };
    if(this.props.offset) {
      offsetStyle.top = -this.props.offset;
    }
    return (
      <div style={{height: 0, position: 'relative'}}>
        <div className={this.props.offsetClassName} ref={this.props.refFunction} style={offsetStyle} />
      </div>
    )
  }
}

export default ScrollOffset;


// WEBPACK FOOTER //
// ./src/components/scrollOffset/ScrollOffset.js